/**
 * @file   src\components\VerificationModal.tsx
 * @brief  VerificationModal component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, Modal } from "../utils/thirdpartyComponents"


const NotificationsModal = (props: any) => {

    const { show, onHide } = props;
    const allowPopup = () => {
      onHide();
      props.handleGetFirebaseToken()
    }

    const handleOnHide = () => {
      sessionStorage.setItem('hideNotificationAllowPopup', 'true');
      onHide();
    }

  return (
    <Modal 
        show={show} 
        onHide={handleOnHide}
        centered
        className='notification-modal'
    >
        <Modal.Body className='text-center'>
            <h6>"Car Wash App" would like to send you Notifications. Permission for this is important for us to notify you regarding:</h6>
            <p className='mb-3'>Deals in your locations <br />
            Location availability <br />
            Reminder for payment etc.</p>
            <p>These can be configured in App Settings on a later time.</p>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className='m-0' onClick={handleOnHide}>Don't Allow</Button>
          <Button variant="primary" className="primary-btn btn-main m-0" onClick={allowPopup}>Allow</Button>
        </Modal.Footer>
      </Modal>
  );
};
export default NotificationsModal;
